import { create } from "zustand";

type TenPercentClaimFormData = {
  userId: string | null;
  tenPercentPersonalInfoDto: Record<string, any> | null;
  tenPercentBankingInfoDto: Record<string, any> | null;
  tenPercentdocuments: {
    identity_document?: File;
    selfie_with_identity?: File;
    liveness_check?: File;
    home_affairs_verification?: File;
    bank_proof?: File;
  };
  removeTenPercentDocument: (key: string) => void;


  setUserId: (id: string) => void;
  setTenPercentPersonalInfoDto: (data: Record<string, any>) => void;
  setTenPercentBankingInfoDto: (data: Record<string, any>) => void;
  addTenPercentDocument: (
    key: keyof TenPercentClaimFormData["tenPercentdocuments"],
    file: File
  ) => void;
  updateTenPercentDocuments: (
    updatedDocs: Partial<TenPercentClaimFormData["tenPercentdocuments"]>
  ) => void;
  clearTenPercentDocuments: () => void;
  getTenPercentFullPayload: () => Record<string, any>;
  reset: () => void;
};

export const useTenPercentClaimFormStore = create<TenPercentClaimFormData>(
  (set, get) => ({
    userId: null,
    tenPercentPersonalInfoDto: null,
    tenPercentBankingInfoDto: null,
    tenPercentdocuments: {},

    setUserId: (id) => set({ userId: id }),
    setTenPercentPersonalInfoDto: (data) =>
      set({ tenPercentPersonalInfoDto: data }),
    setTenPercentBankingInfoDto: (data) =>
      set({ tenPercentBankingInfoDto: data }),
    addTenPercentDocument: (key, file) =>
      set((state) => ({
        tenPercentdocuments: { ...state.tenPercentdocuments, [key]: file },
      })),
    updateTenPercentDocuments: (updatedDocs) =>
      set((state) => ({
        tenPercentdocuments: {
          ...state.tenPercentdocuments,
          ...updatedDocs,
        },
      })),
    clearTenPercentDocuments: () => set({ tenPercentdocuments: {} }),
      removeTenPercentDocument: (key: string) =>
  set((state) => {
    const updated:any = { ...state.tenPercentdocuments };
    delete updated[key];
    return { tenPercentdocuments: updated };
  }),

    getTenPercentFullPayload: () => {
      const { userId, tenPercentPersonalInfoDto, tenPercentBankingInfoDto } =
        get();
      const payload: Record<string, any> = {
        tenPercentPersonalInfoDto,
        tenPercentBankingInfoDto,
      };
      if (userId) {
        payload.userId = userId;
      }
      return payload;
    },
    reset: () =>
      set({
        userId: null,
        tenPercentPersonalInfoDto: null,
        tenPercentBankingInfoDto: null,
        tenPercentdocuments: {},
      }),
  })
);
